// Copyright (c) 2022-2024. Sendanor <info@sendanor.fi>. All rights reserved.

import { isNumber } from "../../../../io/hyperify/core/types/Number";
import { TranslationParams } from "../../../../io/hyperify/core/types/TranslationParams";
import { useStoreStatistics } from "../../../../io/hyperify/frontend/hooks/useStoreStatistics";
import { COMPANY_ACTIVE_YEARS } from "../../core/constants/company";

/**
 *
 */
export function useTranslationParamsWithStatistics () : TranslationParams {
    const statistics = useStoreStatistics();
    const invoiceSum : number = isNumber(statistics?.invoiceSum) ? statistics?.invoiceSum : 0;
    return {
        YEARS                 : COMPANY_ACTIVE_YEARS,
        CLIENT_COUNT          : statistics?.clients  ?? 0,
        INVOICE_COUNT         : statistics?.invoices ?? 0,
        PAYMENT_COUNT         : statistics?.payments ?? 0,
        BUSINESS_CLIENT_COUNT : statistics?.businessClients ?? 0,
        PERSONAL_CLIENT_COUNT : statistics?.personalClients ?? 0,
        INVOICE_SUM           : invoiceSum.toFixed(0),
    };
}
